import { RuntimeEnvTagCorner } from "@/components/elements/RuntimeEnvTag";
import { logout } from "@/utils/logout";
import { Box } from "@mui/material";
import { FC, useLayoutEffect } from "react";
import { Outlet } from "react-router-dom";

export const LoginLayout: FC = () => {
  // If a token is present, force a logout by clearing auth-related web storage only
  useLayoutEffect(() => {
    logout();
  }, []);
  return (
    <Box width="100%" display="flex" justifyContent="center" mt={13} position="relative">
      <RuntimeEnvTagCorner />
      <Outlet />
    </Box>
  );
};
